var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout_c"},[_c('div',{staticClass:"top"},[_c('top')],1),_c('div',{class:_vm.$route.fullPath.indexOf('index') !== -1 ? 'member-right-navbar-index' : 'member-right-navbar'},[_c('app-main',{staticClass:"main"})],1),_c('div',{staticClass:"bottom"},[_c('bottom')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }